import React from 'react'
import LineChart from '../charts/Line'

function Graph() {
   return (
      <div>
         <LineChart />
      </div>
   )
}

export default Graph


